module.exports = __webpack_public_path__ + "img/counterFloodControl_checked.865daba0.png";